let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6MTjC")).then(() => parcelRequire('7TaA0'));